//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations } from "vuex";
import AQDialog from "../../Generics/AQDialog/AQDialog.vue";

export default {
    name: "QfLayers",
    components: { AQDialog },
    props: {
        events: { type: Boolean, default: false },
        canDelete: { type: Boolean, default: false }
    },
    data() {
        return {
            treeThumb: {
                right: "-3px", borderRadius: "2px", width: "3px", opacity: 0.4
            },
            selected: null,
            nodesExpanded: [],
            searchText: null,
            showSearch: false,
            searchInScripts: false,
            deleteAlert: false
        };
    },
    computed: {
        ...mapState("components", ["fragments", "readOnly", "properties", "activeComponent", "components"]),
        ...mapGetters("components", ["body"]),
        treeData() {
            const tree = [{
                label: "Body", children: [], header: "generic", icon: "mdi-folder", key: "body", handler: this.nodeClick
            }];
            const parseBody = (body, treeData, parentList, traversePath) => {
                if (body && body.length) {
                    body.forEach(component => {
                        const properties = this.properties[component.guid];
                        const { __generics, __component } = properties;
                        const configProperties = this.components[__component];
                        const events = this.checkEvents(properties);
                        const newChild = {};
                        const isFragment = configProperties.componentName === "ctrl-fragment";
                        const entryTraversePath = [...traversePath, component.guid];

                        newChild.header = "generic";
                        newChild.code = __generics.code;
                        newChild.key = component.guid;
                        newChild.label = isFragment && this.fragments[properties.fragment]
                            ? this.fragments[properties.fragment].name : properties.label || component.guid;
                        newChild.icon = configProperties.icon || "mdi-puzzle";
                        newChild.children = [];
                        newChild.parentList = parentList;
                        newChild.traversePath = entryTraversePath;
                        newChild.handler = this.nodeClick;

                        if (events.length) {
                            newChild.hasScript = true;
                            newChild.events = events;
                        } else {
                            newChild.hasScript = false;
                            newChild.events = [];
                        }

                        if (!isFragment) {
                            const entryParentList = [...newChild.parentList, newChild.key];
                            parseBody(component.body, newChild.children, entryParentList, entryTraversePath);
                        }
                        treeData.push(newChild);
                    });
                }
            };

            parseBody(this.body, tree[0].children, ["body"], []);
            return tree;
        },
        readonlyPermission() {
            return this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly;
        }
    },
    watch: {
        activeComponent(guid) {
            this.selected = guid;
        }
    },
    methods: {
        ...mapMutations("components", ["removeComponent"]),
        getEventClass(event, key) {
            const classes = [];
            if (this.showSearch && this.searchInScripts && this.searchText) {
                const lowerSearchText = this.searchText.toLowerCase();
                const properties = this.properties[key];
                const text = properties.__events[event] || properties.__customEvents[event] || "";

                if (text.toLowerCase().includes(lowerSearchText)) {
                    classes.push("text-red");
                }
            }

            return classes;
        },
        toggleSearchScript() {
            this.searchInScripts = !this.searchInScripts;
        },
        toggleSearch() {
            this.showSearch = !this.showSearch;
            if (this.showSearch) {
                this.$nextTick(() => {
                    const { searchText } = this.$refs;
                    searchText.focus();
                });
            } else {
                this.searchText = null;
            }
        },
        treeFilter(node) {
            const { label, key, code } = node;
            const lowerSearchText = this.searchText.toLowerCase();
            let filterResult = (key === this.searchText) || (code === this.searchText) || label.toLowerCase().includes(lowerSearchText);

            if (!filterResult && this.searchInScripts && this.properties[key]) {
                const { __events = {}, __customEvents = {} } = this.properties[key];
                const events = [...Object.values(__events), ...Object.values(__customEvents)];

                filterResult = events.some(script => (script || "").toLowerCase().includes(lowerSearchText));
            }

            // const searchList = [key, code, label.toLowerCase()];
            return filterResult;
        },
        checkEvents(properties) {
            const events = [];
            const { __events = {}, __customEvents = {} } = properties;

            [__events, __customEvents].forEach(entity => {
                Object.keys(entity).forEach(key => {
                    if (entity[key]) {
                        events.push(key);
                    }
                });
            });
            return events;
        },
        editEvent(event, key) {
            this.$emit("edit-script", { event, key });
        },
        nodeClick(node) {
            this.$emit("node-click", node);
        },
        collapseElements() {
            this.$refs.layersTree.collapseAll();
        },
        expandElements() {
            this.$refs.layersTree.expandAll();
        },
        targetElement() {
            if (this.activeComponent) {
                const node = this.$refs.layersTree.getNodeByKey(this.activeComponent);
                const parentList = [...node.parentList];
                const [last] = parentList.splice(-1);

                // selectedNode = this.$refs.treeLayerScroll.$el.querySelector(".q-tree-node-selected"),
                // waitForClientRects = () => {
                //     let clientRects = selectedNode.getClientRects();
                //     if (clientRects.length) {
                //         let scrollRects = this.$refs.treeLayerScroll.$el.getClientRects()[0],
                //             scroll = clientRects[0].top - scrollRects.top - Math.round(scrollRects.height / 2);
                //
                //         if (scroll > 0) {
                //             this.$refs.treeLayerScroll.setScrollPosition(scroll);
                //         }
                //     } else {
                //         setTimeout(waitForClientRects, 1);
                //     }
                // };

                if (!this.nodesExpanded.includes(last)) {
                    this.nodesExpanded.push(last);
                }
                this.$nextTick(() => {
                    parentList.forEach(parent => {
                        if (!this.nodesExpanded.includes(parent)) {
                            this.nodesExpanded.push(parent);
                        }
                    });
                });
                // waitForClientRects();
            }
        },
        classList(guid) {
            const classes = ["text-caption"];

            if (this.activeComponent === guid) {
                classes.push("qf-node-active");
            }

            return classes;
        },
        removeNode() {
            if (this.activeComponent) {
                this.removeComponent(this.activeComponent);
            }
        }
    }
};
